export default __webpack_public_path__ + "static/media/coordinador.63e85e4c.svg";